export default [
  {
    path: "productCode",
    label: "Product Code"
  },
  {
    path: "manufacturer",
    label: "Manufacturer"
  },
  {
    path: "description[0].value",
    label: "Description"
  },
  {
    path: "category.name",
    label: "Category"
  },
  {
    path: "subcategory.name",
    label: "Subcategory"
  }
];
